import React from 'react';
import { Box } from '@mui/material';
import { keyframes } from '@mui/system';

const HeroMarkLiquidGlass = () => {
  const float = keyframes({
    '0%, 100%': { transform: 'translateY(0px)' },
    '50%': { transform: 'translateY(-7px)' },
  });

  const drift = keyframes({
    '0%': { transform: 'translate3d(-12%, -8%, 0) scale(1.05)' },
    '50%': { transform: 'translate3d(10%, 8%, 0) scale(1.12)' },
    '100%': { transform: 'translate3d(-12%, -8%, 0) scale(1.05)' },
  });

  const sheen = keyframes({
    '0%': { transform: 'translateX(-160%) rotate(22deg)', opacity: 0 },
    '15%': { opacity: 0.32 },
    '45%': { opacity: 0.18 },
    '100%': { transform: 'translateX(160%) rotate(22deg)', opacity: 0 },
  });

  return (
    <Box
      sx={{
        width: { xs: 96, md: 136 },
        height: { xs: 96, md: 136 },
        mx: 'auto',
        mb: 4,
        borderRadius: { xs: 6, md: 7 },
        position: 'relative',
        overflow: 'hidden',
        display: 'grid',
        placeItems: 'center',
        bgcolor: 'rgba(255,255,255,0.10)',
        border: '1px solid rgba(255,255,255,0.28)',
        backdropFilter: 'blur(18px)',
        boxShadow: '0 22px 70px rgba(0,0,0,0.26)',
        animation: `${float} 6.2s ease-in-out infinite`,
        transform: 'translateZ(0)',
        '&::before': {
          content: '""',
          position: 'absolute',
          inset: -30,
          background:
            'radial-gradient(40% 35% at 30% 30%, rgba(255,255,255,0.34), rgba(255,255,255,0) 60%), radial-gradient(45% 40% at 75% 70%, rgba(255,255,255,0.20), rgba(255,255,255,0) 62%), radial-gradient(55% 45% at 60% 35%, rgba(255,255,255,0.16), rgba(255,255,255,0) 64%)',
          animation: `${drift} 8.5s ease-in-out infinite`,
          filter: 'blur(0.5px)',
          opacity: 0.95,
        },
        '&::after': {
          content: '""',
          position: 'absolute',
          top: -60,
          bottom: -60,
          width: '42%',
          left: '50%',
          background:
            'linear-gradient(90deg, rgba(255,255,255,0), rgba(255,255,255,0.26), rgba(255,255,255,0))',
          transform: 'translateX(-160%) rotate(22deg)',
          animation: `${sheen} 6.4s ease-in-out infinite`,
          pointerEvents: 'none',
        },
        '&:hover': {
          transform: 'translateZ(0) scale(1.02)',
          boxShadow: '0 28px 90px rgba(0,0,0,0.30)',
        },
        transition: 'transform 240ms ease, box-shadow 240ms ease',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          inset: 2,
          borderRadius: { xs: 5.5, md: 6.5 },
          background:
            'linear-gradient(135deg, rgba(0,0,0,0.16), rgba(0,0,0,0.06))',
          boxShadow:
            'inset 0 0 0 1px rgba(255,255,255,0.14), inset 0 -18px 40px rgba(0,0,0,0.12)',
          zIndex: 1,
        }}
      />
      <Box
        component="img"
        src={`${process.env.PUBLIC_URL}/brand/lexory-icon.png`}
        alt="Lexory"
        sx={{
          width: { xs: 44, md: 60 },
          height: { xs: 44, md: 60 },
          zIndex: 2,
          filter: 'drop-shadow(0 14px 26px rgba(0,0,0,0.32))',
          opacity: 0.98,
        }}
      />
    </Box>
  );
};

export default HeroMarkLiquidGlass;
